// extracted by mini-css-extract-plugin
export default {"Card":"RoadMap_Card__BJzVN","Color":"RoadMap_Color__mXEug","road_img":"RoadMap_road_img__SPdn3"};